/** Keys for chip/option highlight: stringified so number `3` matches form value `"3"`. */
export const toHighlightedIdKeySet = (value: unknown): Set<string> => {
  if (!Array.isArray(value)) {
    return new Set();
  }

  return new Set(
    value
      .filter(id => id !== null && id !== undefined && id !== "")
      .map(id => String(id)),
  );
};

export const isHighlightedId = ({
  option,
  highlightedIdKeys,
}: {
  option: string | number;
  highlightedIdKeys: ReadonlySet<string>;
}): boolean => highlightedIdKeys.has(String(option));
